module.exports = __webpack_public_path__ + "static/media/high-difficulty-selected.48f78ea7.svg";